import * as formik from 'formik';
import * as fabric from 'office-ui-fabric-react';
import { FC, useEffect } from 'react';
import { toast } from 'react-toastify';
import * as Yup from 'yup';
import * as api from '../../../../../../api/generated';
import { KendoLoading } from '../../../../../../components';
import { IInfoScreenWorkScheduleSettings } from './LocationConfigInfoScreenScheduleWindow';

interface IProps {
    infoScreenId: number;
    settings: IInfoScreenWorkScheduleSettings | null;
    setSettings: Function;
    fetchSettings: Function;
}

const validationSchema = Yup.object<IInfoScreenWorkScheduleSettings>().shape({
    title: Yup.string().max(50, 'Maksimalus lauko ilgis: 50 simbolių')
});

const LocationConfigInfoScreenScheduleSettings: FC<IProps> = (props) => {
    useEffect(() => {}, []);

    const handleSubmit = async (values: IInfoScreenWorkScheduleSettings, formikActions: formik.FormikHelpers<IInfoScreenWorkScheduleSettings>) => {
        try {
            await api.workschedule.updateInfoScreenWorkScheduleSettings({
                infoScreenId: props.infoScreenId,
                title: values.title,
                isWorkScheduleTitleShown: values.isWorkScheduleTitleShown,
                options: values.options.map((x) => ({
                    key: parseInt(x.key.toString()),
                    text: x.text,
                    selected: x.selected ?? false
                }))
            });

            toast.success('Informacija sėkmingai išsaugota');
            props.setSettings(null);
            await props.fetchSettings();
            formikActions.resetForm();
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };
    return (
        <div className="ms-Grid" dir="ltr">
            {!props.settings && <KendoLoading />}
            {props.settings && (
                <formik.Formik
                    validationSchema={validationSchema}
                    initialValues={{ ...props.settings }}
                    onSubmit={handleSubmit}
                    render={(formikProps) => (
                        <formik.Form>
                            <div className="ms-Grid-row">
                                <fabric.Text style={{ fontWeight: 'lighter' }} variant="large">
                                    Tvarakraščio nustatymai
                                </fabric.Text>
                                <fabric.Separator />
                            </div>
                            <div className="ms-Grid-row">
                                <div className="ms-Grid-col ms-md4">
                                    <formik.Field
                                        name="title"
                                        render={({ field, form }: formik.FieldProps<string>) => (
                                            <fabric.TextField
                                                {...field}
                                                label="Tvarkaraščio pavadinimas"
                                                errorMessage={
                                                    (formikProps.status && formikProps.status.title) || (form.errors.title && form.errors.title)
                                                }
                                            />
                                        )}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-3">
                                    <formik.Field
                                        name="isWorkScheduleTitleShown"
                                        render={({ field, form }: formik.FieldProps<boolean>) => (
                                            <fabric.Toggle
                                                {...field}
                                                label="Rodyti/nerodyti tvarkaraščio pavadinimą"
                                                defaultChecked={field.value}
                                                onChange={() => form.setFieldValue(field.name, !field.value)}
                                                onText="Įjungta"
                                                offText="Išjungta"
                                            />
                                        )}
                                    />
                                </div>
                                <div className="ms-Grid-col ms-md4">
                                    <formik.Field
                                        name="options"
                                        render={({ field, form }: formik.FieldProps<fabric.IDropdownOption[]>) => (
                                            <fabric.Dropdown
                                                {...field}
                                                label="Ekranai, kurių tvarkaraščiai bus atvaizduojami"
                                                onChange={(e: any, i: fabric.IDropdownOption | undefined) => {
                                                    if (i) {
                                                        var itemIndex = field.value.findIndex((x) => x.key === i.key);
                                                        var result = [...field.value];
                                                        result[itemIndex] = i;
                                                        form.setFieldValue(field.name, result);
                                                        formikProps.setTouched(e);
                                                    }
                                                }}
                                                options={props.settings!.options}
                                                multiSelect
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            <div className="ms-Grid-row">
                                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                                    <fabric.PrimaryButton
                                        className="ms-slideRightIn40 ms-textAlignRight"
                                        text="Išsaugoti"
                                        disabled={formikProps.isSubmitting || !formikProps.isValid || !formikProps.dirty}
                                        type="submit"
                                    />
                                </div>
                            </div>
                        </formik.Form>
                    )}
                />
            )}
            <fabric.Separator />
        </div>
    );
};

export default LocationConfigInfoScreenScheduleSettings;
